/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class CandidateCollaboratorEntity extends Entity {
  candidateId: string | null = null;
  collaboratorId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  updatedAt: string | null = null;
  static override key = 'CandidateCollaborator';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateCollaborator' in input
    ) {
      const { CandidateCollaborator: wrapped, ...rest } = input as {
        CandidateCollaborator: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}